<template>
  <div>
    <div class="over-lay" @click="closePopup()"></div>
    <div class="popup">
      <span class="close-hldr" @click="closePopup()">
        <i class="material-icons">close</i>
      </span>
      <img class="sf-icon" src="@/assets/icons/png/crm/Salesforce.png" />
      <div class="sf-content">
        Connect your Salesforce account with Adapt
      </div>
      <span class="sf-content sub-para">
        Once connected, you can export leads to Salesforce in 1 click as soon as
        you find their email address.
      </span>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    closePopup() {
      this.$emit('clickedOutside', true)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.over-lay {
  background: rgb(0, 0, 0, 0.85);
  position: fixed;
  height: 100%;
  top: 0px;
  width: 100%;
  left: 0;
  z-index: 3;
}
.popup {
  position: fixed;
  width: 85%;
  max-width: 360px;
  padding-top: 70px;
  padding-bottom: 30px;
  color: #474542;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  will-change: transform;
  border-radius: 6px;
  background-color: $white;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: initial;
  cursor: default;
  .close-hldr {
    position: absolute;
    right: 6px;
    top: 8px;
    display: flex;
    i {
      font-size: 15px;
      cursor: pointer;
      color: #787878;
    }
  }
  .sf-icon {
    position: absolute;
    width: 60px;
    height: auto !important;
    top: 18px;
  }
  .sf-content {
    text-align: center;
    padding: 8px 20px;
    font-size: 14px;
  }
  .sub-para {
    font-size: 12px;
    background-color: #f7f7f7;
    margin-top: 10px;
    margin-bottom: 20px;
    color: $text-dark;
  }
}
</style>
